import { useGet } from '@geprog/use-feathers';

import useFeathers, { ClientApplication } from './useFeathers';

export default useGet<ClientApplication>(useFeathers());
